const env = {
    api: window?.env?.REACT_APP_API_URL,
    appEnv: window?.env?.REACT_APP_ENV,
    secret:"@edemo#68$%"
}
export default env;